import { connect } from 'react-redux';
import Component from './component';
import { updatePassword, checkUpdatePasswordToken } from '../../../actions/auth'

export default connect(
  state => ({
    updateToken: state.auth.updateToken.token,
    status: state.auth.updateToken.status
  }),
  dispatch => ({
    checkUpdatePasswordToken: (updateToken) => dispatch(checkUpdatePasswordToken(updateToken)),
    updatePassword: (password, updateToken) => dispatch(updatePassword(password, updateToken))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/auth/UpdatePassword/index.js